/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductListContainerViewProps } from './product-list-container';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

const ProductListContainerView:React.FC<IProductListContainerViewProps>=(props)=> {
    const{
        productListContainer,
        productListDetailsContainer,
        contents,
        productListItem,
        categoryName,
        categoryCopy,
        message
    }=props;
    if(!contents||contents.length===0){
        return(
            <Module {...productListContainer} className="product-list-empty">
            <Node {...productListDetailsContainer}>
                {categoryName}
                {categoryCopy}
                {message}
            </Node>
        </Module>
        );
    }
    
    
   
    return (
        <Module {...productListContainer}>
            <Node {...productListDetailsContainer}>
                {categoryName}
                {categoryCopy}
            </Node>
            <div className='container'>
                <div className='row'>
                    {contents.map((content:any,index:number)=>{
                        return(
                                <Node {...productListItem} className="col-md-6 col-lg-3 col-sm-12 product-list-container__item">
                                    {content}
                                </Node>
                        );
                    })}
                </div>
            </div>
        </Module>
    );
};
export default ProductListContainerView